export class FormUtils {

  public static getValueIfValidCondition(valid: boolean, value: any) {
    if (valid && valid === true) {
      return value ? value : undefined
    }
    return undefined;
  }

  public static getStringValueIfValidCondition(valid: boolean, value: any): string | undefined {
    if (valid && valid === true) {
      return  value && value?.length > 0 ? value : undefined
    }
    return undefined;
  }

  public static getBooleanValueIfValidCondition(valid: boolean, value: any): boolean {
    if (valid && valid === true && value && value === true) {
      return true;
    }
    return false;
  }
}
